import { render, staticRenderFns } from "./ModalForm.vue?vue&type=template&id=3137b350&scoped=true"
import script from "./ModalForm.ts?vue&type=script&lang=ts&external"
export * from "./ModalForm.ts?vue&type=script&lang=ts&external"
import style0 from "./ModalForm.vue?vue&type=style&index=0&id=3137b350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3137b350",
  null
  
)

export default component.exports